"use client";

import { SessionProvider } from "next-auth/react";
import ThemeController from "@/components/ThemeController";

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider>
      <ThemeController />
      {children}
    </SessionProvider>
  );
}
